var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eulg9g89rgf1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.483000 93.050000",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #eulg9g89rgf4 {\n        animation: eulg9g89rgf4_c_o 3000ms linear infinite normal forwards;\n        }\n\n        @keyframes eulg9g89rgf4_c_o {\n        0% {\n        opacity: 1;\n        }\n\n        50% {\n        opacity: 0.3;\n        }\n\n        100% {\n        opacity: 1;\n        }\n        }>\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eulg9g89rgf2",
    transform: "matrix(1 0 0 1 2010.86999999999989 1866.36999999999989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eulg9g89rgf3",
    d: "M-40.376117,-20.733587C-47.310429,-20.734075,-52.931678,-26.355324,-52.932166,-33.289637L-27.819184,-33.289637C-27.819672,-26.354979,-33.441459,-20.733587,-40.376117,-20.733587M-7.480751,-38.254108C-7.743880,-56.234294,-22.394006,-70.672372,-40.376117,-70.673344C-58.544154,-70.672856,-73.272273,-55.945132,-73.273249,-37.777095C-73.273483,-29.052080,-69.807649,-20.684339,-63.638214,-14.514739C-57.468780,-8.345138,-49.101132,-4.879079,-40.376117,-4.879079L-40.376117,11.521344C-20.618217,3.311453,-7.671314,-15.902559,-7.480751,-37.297432C-7.480751,-37.455553,-7.480751,-37.616324,-7.480751,-37.777095C-7.480751,-37.937866,-7.480751,-38.098637,-7.480751,-38.255875",
    transform: "matrix(1 0 0 1 -1933.25000000000000 -1790.26999999999998)",
    fill: "rgb(255,255,255)",
    stroke: "rgb(0,255,255)",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eulg9g89rgf4",
    transform: "matrix(1 0 0 1 2010.86999999999989 1866.36999999999989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eulg9g89rgf5",
    d: "M-40.376117,-20.733587C-47.310429,-20.734075,-52.931678,-26.355324,-52.932166,-33.289637L-27.819184,-33.289637C-27.819672,-26.354979,-33.441459,-20.733587,-40.376117,-20.733587M-7.480751,-38.254108C-7.743880,-56.234294,-22.394006,-70.672372,-40.376117,-70.673344C-58.544154,-70.672856,-73.272273,-55.945132,-73.273249,-37.777095C-73.273483,-29.052080,-69.807649,-20.684339,-63.638214,-14.514739C-57.468780,-8.345138,-49.101132,-4.879079,-40.376117,-4.879079L-40.376117,11.521344C-20.618217,3.311453,-7.671314,-15.902559,-7.480751,-37.297432C-7.480751,-37.455553,-7.480751,-37.616324,-7.480751,-37.777095C-7.480751,-37.937866,-7.480751,-38.098637,-7.480751,-38.255875",
    transform: "matrix(1 0 0 1 -1933.25000000000000 -1790.26999999999998)",
    fill: "rgb(15,237,178)",
    stroke: "none",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b49235aeb31a6f9630b22b5329ac2578.svg";
export { ForwardRef as ReactComponent };